<div class="listing-page-wrapper">
  <div class="page-header">
    <div class="header-row">
      <div></div><!-- spacer -->
      <!-- Actions -->
      <div class="page-actions">
        <button class="btn btn-primary" (click)="addCompany()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          Add Company
        </button>
      </div>
    </div>
  </div>

  <div class="company-list-container">

    <!-- FILTERS SECTION -->
    <div class="filters-section">
      <div class="filters-row">

        <!-- Filter Chips -->
        <div class="filter-chip" [class.active]="activeFilter === 'all'" (click)="onFilterChange('all')">
          All Companies
          <span class="count">{{ getFilterCount('all') }}</span>
        </div>
        <div class="filter-chip" [class.active]="activeFilter === 'store'" (click)="onFilterChange('store')">
          Store
          <span class="count">{{ getFilterCount('store') }}</span>
        </div>
        <div class="filter-chip" [class.active]="activeFilter === 'contractor'" (click)="onFilterChange('contractor')">
          Contractor
          <span class="count">{{ getFilterCount('contractor') }}</span>
        </div>
        <div class="filter-chip" [class.active]="activeFilter === 'others'" (click)="onFilterChange('others')">
          Others
          <span class="count">{{ getFilterCount('others') }}</span>
        </div>

        <!-- Search Box -->
        <div class="search-box">
          <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
          </svg>
          <input type="text" class="search-input" placeholder="Search companies..." [(ngModel)]="searchTerm"
            (input)="onSearch()">
        </div>
        <svg *ngIf="searchTerm" (click)="clearText()" class="cross-icon" width="16" height="16"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    </div>

    <!-- TABLE SECTION -->
    <div class="table-section">
      <div class="table-wrapper">
        <table class="company-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Company Name</th>
              <th>Total Orders</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody *ngIf="!isLoading || companyData?.length > 0">
            <tr *ngFor="let company of companyData; let i = index">
              <td>{{ company.sNo}}</td>
              <td>
                <div class="company-cell">
                  <div class="company-avatar" [ngClass]="company.avatarClass">{{ getCompanyInitials(company.company) }}
                  </div>
                  <div class="company-info">
                    <div class="company-name">{{ company.company }}</div>
                  </div>
                </div>
              </td>
              <td>{{ company.order_count }}</td>
              <td>
                <div class="actions-cell">
                  <button class="action-btn merge-btn" title="Merge Company" (click)="openMergeModal(company)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                    </svg>
                  </button>
                  <button *ngIf="company.has_duplicates" class="action-btn view-btn" (click)="viewCompany(company)"
                    title="View Details">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </button>
                  <button *ngIf="!company.has_duplicates" class="action-btn edit-btn" title="Edit"
                    (click)="openEditModal(company)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                    </svg>
                  </button>
                  <button *ngIf="!company.has_duplicates" class="action-btn delete-btn" title="Delete"
                    (click)="deleteOrder(company.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="companyData?.length === 0">
              <td colspan="5" style="text-align: center; padding: 40px; color: #9ca3af;">
                <svg class="nav-icon" fill="currentColor" viewBox="0 0 20 20"
                  style="width: 48px; height: 48px; margin: 0 auto 16px; opacity: 0.5;">
                  <path fill-rule="evenodd"
                    d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                    clip-rule="evenodd" />
                </svg>
                <div style="font-size: 16px; font-weight: 500; margin-bottom: 4px;">No companies found</div>
                <div style="font-size: 14px;">Try adjusting your search or filters</div>
              </td>
            </tr>
          </tbody>

          <!-- Skeleton Rows -->
          <tbody *ngIf="isLoading && (!companyData || companyData.length === 0)">
            <tr *ngFor="let item of [1,2,3,4,5,6,7,8,9,10]">
              <td><div class="skeleton-line" style="width: 20px;"></div></td>
              <td>
                <div class="company-cell">
                  <div class="skeleton-avatar"></div>
                  <div class="company-info">
                    <div class="skeleton-line" style="width: 120px;"></div>
                  </div>
                </div>
              </td>
              <td><div class="skeleton-line" style="width: 40px; margin: 0 auto;"></div></td>
              <td>
                <div class="actions-cell">
                  <div class="skeleton-icon-btn"></div>
                  <div class="skeleton-icon-btn"></div>
                  <div class="skeleton-icon-btn"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- PAGINATION FOOTER -->
    <div class="">
      <div class="pagination-controls pagination-footer">
        <button class="nav-arrow" [disabled]="currentPage === 1" (click)="goToPreviousPage()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>

        <div class="pagination-info">
          {{ getPaginationInfo() }}
        </div>

        <button class="nav-arrow" [disabled]="currentPage === totalPages" (click)="goToNextPage()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- MERGE COMPANY MODAL -->
  <div class="modal" [class.show]="showMergeModal" (click)="onModalBackdropClick($event)">
    <div class="modal-content overflow-visible">
      <div class="modal-header">
        <h2 class="modal-title">
          <svg class="modal-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
          </svg>
          Merge Companies
        </h2>
        <button class="modal-close" (click)="closeMergeModal()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body overflow-visible">
        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" />
            </svg>
            Company to Merge
          </label>
          <input type="text" class="modal-input modal-input-readonly" [value]="currentCompany?.company" readonly>
        </div>

        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
            Merge Into
          </label>
          <div class="combo-input-wrapper" (click)="$event.stopPropagation()">
            <input type="text" class="modal-input combo-input" [(ngModel)]="mergeToInput"
              placeholder="Search or select company..." autocomplete="off" (input)="onMergeInputChange()">
            <div class="error-text" *ngIf="!mergeToInput && isMerge">
              Merge Into is required
            </div>
            <svg class="combo-chevrons" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
            <div class="combo-dropdown" *ngIf="showMergeDropdown">
              <div class="combo-option" *ngFor="let company of filteredMergeCompanies"
                (click)="selectMergeCompany(company)">
                <div class="option-info">
                  <div class="option-name">{{ company.company }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="info-box info-warning">
          <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          <div>
            <div class="info-title">This action cannot be undone</div>
            <div class="info-text">All data from the merged company will be transferred and the original company will be
              deleted.</div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-secondary" (click)="closeMergeModal()">Cancel</button>
        <button class="btn-primary" (click)="confirmMerge()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Merge Companies
        </button>
      </div>
    </div>
  </div>

  <!-- EDIT COMPANY MODAL -->
  <div class="modal edit-modal" [class.show]="showEditModal" (click)="onModalBackdropClick($event)">
    <div class="modal-content overflow-visible">
      <div class="modal-header">
        <h2 class="modal-title">
          <svg class="modal-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
          </svg>
          Edit Company
        </h2>
        <button class="modal-close" (click)="closeEditModal()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body overflow-visible">
        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" />
            </svg>
            Company Name
            <span class="required">*</span>
          </label>
          <input type="text" class="modal-input" [(ngModel)]="editCompanyName" placeholder="Enter company name">
          <div class="error-text" *ngIf="!editCompanyName && isEdit">
            Company Name is required
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
            </svg>
            Address
            <span class="required">*</span>
          </label>
          <div class="combo-input-wrapper" (click)="$event.stopPropagation()">
            <div class="d-flex">
              <input type="text" class="modal-input combo-input" [(ngModel)]="addressInput"
                placeholder="Search or select address..." autocomplete="off" (focus)="onAddressInputFocus()"
                (input)="onAddressInputChange()">
              <button class="btn-primary" style="position: relative;left: 11px;" (click)="openDialog('0ms', '0ms')">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add Address
              </button>
            </div>
            <div class="error-text" *ngIf="!addressInputselection && isEdit">
              Address is required
            </div>
            <svg class="combo-chevron" [class.move-down]="!addressInputselection && isAdded"
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
            <div class="combo-dropdown" *ngIf="showAddressDropdown">
              <div class="combo-option" *ngFor="let address of addressData" (click)="selectAddress(address)">
                <svg class="option-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                <div class="option-info">
                  <div class="option-name">{{ address.address }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-secondary" (click)="closeEditModal()">Cancel</button>
        <button class="btn-primary" (click)="confirmEdit()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Update Company
        </button>
      </div>
    </div>
  </div>

  <!-- ADD COMPANY MODAL -->
  <div class="modal" [class.show]="showAddModal" (click)="onModalBackdropClick($event)">
    <div class="modal-content overflow-visible">
      <div class="modal-header">
        <h2 class="modal-title">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="modal-icon">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          Add Company
        </h2>
        <button class="modal-close" (click)="closeAddModel()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body overflow-visible">
        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" />
            </svg>
            Company Name
            <span class="required">*</span>
          </label>
          <input type="text" class="modal-input" [(ngModel)]="editCompanyName" placeholder="Enter company name">
          <div class="error-text" *ngIf="!editCompanyName && isAdded">
            Company Name is required
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">
            <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
            </svg>
            Address
            <span class="required">*</span>
          </label>
          <div class="combo-input-wrapper" (click)="$event.stopPropagation()">
            <div class="d-flex">
              <input type="text" class="modal-input combo-input" [(ngModel)]="addressInput"
                placeholder="Search or select address..." autocomplete="off" (focus)="onAddressInputFocus()"
                (input)="onAddressInputChange()">
              <button class="btn-primary" style="position: relative;left: 11px;" (click)="openDialog('0ms', '0ms')">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add Address
              </button>
            </div>
            <div class="error-text" *ngIf="!addressInput && isAdded">
              Address is required
            </div>
            <svg class="combo-chevron" [class.move-down]="!addressInputselection && isAdded"
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
            <div class="combo-dropdown" *ngIf="showAddressDropdown">
              <div class="combo-option" *ngFor="let address of addressData" (click)="selectAddress(address)">
                <svg class="option-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                <div class="option-info">
                  <div class="option-name">{{ address.address }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-secondary" (click)="closeAddModel()">Cancel</button>
        <button class="btn-primary" (click)="confirmAdd()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Add Company
        </button>
      </div>
    </div>
  </div>

  <!-- VIEW COMPANY MODAL -->
  <div class="modal" [class.show]="showviewModal" (click)="onModalBackdropClick($event)">
    <div class="modal-content" style="max-width: 1000px; width: 95%;">
      <div class="modal-header">
        <h2 class="modal-title">
          <svg style="width: 24px;height: 24px;color: #00a862;" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          View Companies
        </h2>
        <button class="modal-close" (click)="closeViewModel()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <!-- TABLE SECTION -->
        <div class="table-section">
          <div class="table-wrapper">
            <table class="company-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Company Name</th>
                  <th>Address</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let company of viewCompanyData; let i = index">
                  <td>{{ company.sNo }}</td>
                  <td>
                    <div class="company-cell">
                      <div class="company-avatar" [ngClass]="company.avatarClass">{{getCompanyInitials(company.company)
                        }}</div>
                      <div class="company-info">
                        <div class="company-name">{{ company.company }}</div>
                      </div>
                    </div>
                  </td>
                  <td>{{ company.address.address}}</td>
                  <td>
                    <div class="actions-cell">
                      <button class="action-btn edit-btn" title="Edit" (click)="openEditModal(company)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                        </svg>
                      </button>
                      <button class="action-btn delete-btn" title="Delete" (click)="deleteOrder(company.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="viewCompanyData?.length === 0">
                  <td colspan="5" style="text-align: center; padding: 40px; color: #9ca3af;">
                    <svg class="nav-icon" fill="currentColor" viewBox="0 0 20 20"
                      style="width: 48px; height: 48px; margin: 0 auto 16px; opacity: 0.5;">
                      <path fill-rule="evenodd"
                        d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                        clip-rule="evenodd" />
                    </svg>
                    <div style="font-size: 16px; font-weight: 500; margin-bottom: 4px;">No companies found</div>
                    <div style="font-size: 14px;">Try adjusting your search or filters</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- VIEW PAGINATION FOOTER -->
        <div class="">
          <div class="pagination-controls pagination-footer">
            <button class="nav-arrow" [disabled]="viewCurrentPage === 1" (click)="goToViewPreviousPage()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </button>

            <div class="pagination-info">
              {{ getViewPaginationInfo() }}
            </div>

            <button class="nav-arrow" [disabled]="viewCurrentPage === viewTotalPages" (click)="goToViewNextPage()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>